import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function ReadingProgress() {
  const { pathname } = useLocation();
  const [progress, setProgress] = useState(0);

  const isBlogArticle = pathname.startsWith("/blog/") && pathname !== "/blog/";

  useEffect(() => {
    if (!isBlogArticle) {
      setProgress(0);
      return;
    }

    const onScroll = () => {
      const scrollY = window.scrollY || window.pageYOffset;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight > 0) {
        const pct = Math.min(100, Math.max(0, (scrollY / docHeight) * 100));
        setProgress(pct);
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    return () => window.removeEventListener("scroll", onScroll);
  }, [pathname, isBlogArticle]);

  if (!isBlogArticle || progress <= 0) return null;

  return (
    <div
      className="reading-progress-bar"
      style={{ width: `${progress}%` }}
      role="progressbar"
      aria-valuenow={Math.round(progress)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label="Reading progress"
    />
  );
}
